import profile from '../assets/images/profile.jpg'

const ABOUT = {
  name: 'Rikzan Fernanda',
  skills: ['Fullstack Developer', 'Laravel', 'Codeigniter', 'ExpressJS', 'React/NextJS', 'React Native', 'Wordpress'],
  profile: profile,
  title: 'Who am I?',
  summary:
    'As a full-stack web developer with expertise in both backend and frontend technologies, I specialize in frameworks like Laravel, CodeIgniter, Express.js, React/Next.js, and React Native. Since starting my programming career in 2021, I have contributed to various projects, including Lingoni.com, Stufast.id, and Sikembang.com. \n \n I excel in both independent and collaborative environments and am dedicated to delivering high-quality solutions that meet client needs and drive business success.',
  links: {
    linkedin: 'https://www.linkedin.com/in/rikzan-fernanda-9097831ab/',
    github: 'https://github.com/rikzanfernanda',
    gitlab: 'https://gitlab.com/rikzanfernanda',
    shutterstock: 'https://www.shutterstock.com/g/rikzan+fernanda',
    behance: 'https://www.behance.net/rikzan_fernanda/projects',
    adobe_stock: 'https://stock.adobe.com/contributor/208855852/rikzan-fernanda?load_type=author',
    upwork: 'https://www.upwork.com/freelancers/~01c2a42b9b92a02bdc',
    projects_co_id: 'https://projects.co.id/public/browse_users/view/0a451e/rikzan-fernanda'
  },
  contact: {
    email: 'rikzanfernanda@gmail.com'
  },
  pdf_projects: 'https://drive.google.com/file/d/1gyHUw8YTLQyE6qvzYT7jV8ol9duzyyTe/view?usp=sharing',
  latest_projects: [
    {
      title: 'fridaysocialapp (Android)',
      link: 'https://play.google.com/store/apps/details?id=com.cube_social_media'
    },
    {
      title: 'fridaysocialapp (IOS)',
      link: 'https://apps.apple.com/us/app/cube-social-app/id1578816229'
    },
    {
      title: 'Fridaysocialapp Website',
      link: 'https://fridaysocial.web.app'
    },
    {
      title: 'indoaddict.com',
      link: 'https://indoaddict.com'
    },
    {
      title: 'FNI Enterprise',
      link: 'https://fni.co.id/products'
    },
    {
      title: 'stufast.id',
      link: 'https://stufast.id'
    },
    {
      title: 'Administrasi Bisnis Polines',
      link: 'https://ab.polines.ac.id'
    }
    // {
    //   title: 'Teknik Telekomunikasi Polines',
    //   link: 'https://te.polines.ac.id/'
    // },
    // {
    //   title: 'Lingoni Wordpress Plugin',
    //   link: 'https://my.lingoni.com'
    // }
  ]
}

export default ABOUT
